<template>
  <div class="contain">
    <div class="layout-index">
      <GuidArea></GuidArea>
    </div>
  </div>
</template>

<script>
import GuidArea from '../../components/home/GuidArea.vue'
export default {
  name: 'Home',
  data() {
    return {}
  },
  components: {
    GuidArea,
  },
}
</script>

<style scoped>
</style>